// extracted by mini-css-extract-plugin
export default {"pullToRefresh":"Mailbox_pullToRefresh__E1QC0"};